import { LayoutHOC } from 'base/ui/layout/layout';
import createConnectMS from '.';

export const createConnectMSPage = (layoutHOC: LayoutHOC) => {
    return layoutHOC(createConnectMS());
};
